import { useEffect } from 'react';
import { getReferenceData } from '../../store/asyncActions';
import { selectCommon, setReferenceData } from '../../store/commonSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

export default function FetchReferenceData(): JSX.Element {
  const dispatch = useAppDispatch();
  const common = useAppSelector(selectCommon);

  useEffect(() => {
    const response = dispatch(getReferenceData());

    response.then((response) => {
      const referenceData = {
        ...common.referenceData,
        ...response.payload,
      };

      const aboveLineForeignTaxCountries = referenceData.countries.filter(
        (x) => x.value !== 'AU' && x.aboveTheLine
      );

      const belowLineForeignTaxCountries = referenceData.countries.filter(
        (x) => x.value !== 'AU' && !x.aboveTheLine
      );

      referenceData.foreignTaxCountries = [
        ...aboveLineForeignTaxCountries,
        ...belowLineForeignTaxCountries,
      ];
      dispatch(setReferenceData(referenceData));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}
